import { reveal } from "@components/animations";
import { Breadcrumbs, ForwardBtn, SkillsCard } from "@components/shared";
import { aboutMePageData } from "@demo-data/about-me";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Button, Grid, Typography } from "@mui/material";
import { Box, Container, Stack, useTheme } from "@mui/system";
import { hexToRGBA } from "@utils/hex-to-rgba";
import { addScriptDefault } from "meta-pixel";
import { CSSProperties } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
// @ts-ignore: side-effect import of CSS module without type declarations
import "react-lazy-load-image-component/src/effects/blur.css";
import { Link } from "react-router-dom";

export default function AboutMePage() {
  const theme = useTheme();
  const { aboutData, mySkills, funFact, overleafResume, image } =
    aboutMePageData || {};
  const fillStyle = {
    "--anim-fill-color": hexToRGBA(theme.palette.primary.main, 0.2),
  } as CSSProperties;

  return (
    <Container maxWidth="lg">
      <Stack gap={4}>
        <Breadcrumbs title="about-me" description={"Who am I?"} />

        <Grid container spacing={{ xs: 2, md: 4 }} alignItems="center">
          <Grid item xs={12} md={4} {...reveal("left")}>
            <Box className="anim-about-photo" sx={{ maxWidth: { md: 400 } }}>
              <LazyLoadImage
                alt="about-image"
                effect="blur"
                src={image}
                width={"100%"}
                height={"100%"}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            <Stack spacing={3}>
              {aboutData.map((data, index) => (
                <Typography
                  {...reveal("up", index * 80)}
                  color="text.secondary"
                  fontWeight={400}
                  fontSize={{
                    xs: 14,
                    sm: 16,
                  }}
                  lineHeight={1.75}
                  key={data.id}
                >
                  {data.text}
                </Typography>
              ))}
              <Box display="flex" {...reveal("up", aboutData.length * 80)}>
                <Button
                  component={Link}
                  target="_blank"
                  rel="noopener noreferrer"
                  to={overleafResume}
                  startIcon={<PictureAsPdfIcon />}
                  variant="outlined"
                  color="primary"
                  className="anim-fill"
                  style={fillStyle}
                  onClick={() => {
                    const fbq = addScriptDefault();
                    fbq("trackCustom", "DownloadCV");
                  }}
                >
                  Download CV
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Stack gap={4}>
          <ForwardBtn title="skills" isShowBackBtn={false} />
          <div className="anim-card-grid">
            {mySkills?.map((skill, index) => (
              <div key={index} {...reveal("up", index * 55)}>
                <SkillsCard title={skill?.title} skills={skill?.items} />
              </div>
            ))}
          </div>
        </Stack>

        <Stack gap={4}>
          <ForwardBtn title="highlights" isShowBackBtn={false} />
          <div className="anim-fact-grid">
            {funFact.map((fact, index) => (
              <div key={fact} {...reveal("up", index * 45)}>
                <div className="anim-fact">{fact}</div>
              </div>
            ))}
          </div>
        </Stack>
      </Stack>
    </Container>
  );
}
